
export function config() {
	var data =
		{
			URL: {
				COMMON: "/",
				API: {
					BASE: "",
					DASHBOARD: {
						read: "",
						search:"/v1/search",
						request: "/v1/faver/request/info",
						faver: "/v1/faver",
						web_search: "/v1/items/web_search",
						item_from_ur: "/v1/items/item_from_url"
					},
					ITEMS: {
						read: "/v1/items",
						read_activity: "/v1/items/user_activity",
					},
					REVIEWS: {
						read: "/v1/items/reviews"
					},
					LISTS: {
						read: "/v1/lists"
					}
				}
			}

		};

	var site_url = location.origin;
	data.URL.API.BASE = ((site_url=='https://app.faver.it')?'https://api.faver.it':'https://old-apifix.faver.it');

	return data;
}



// WEBPACK FOOTER //
// ./src/client/base/URL.Config.js